<template>
    <div class="observation-group border border-dark" :class="isSuccess ? 'is-success' : 'is-error'">
        <h3><editable-text-field v-model="title" :defaultValue="defaultTitle" placeholder="Observation group title"></editable-text-field></h3>
        <div class="alert alert-danger" v-if="error">
            <strong>Error:</strong> {{ error }}
        </div>
        <observation
                class="mb-3"

                :observationGroupId="id + ''"

                v-for="(observationId, i) in observationIds"
                v-on:delete="onObservationDelete(observationId)"
                v-on:moveUp="onObservationMoveUp(i, observationId)"
                v-on:moveDown="onObservationMoveDown(i, observationId)"

                :key="observationId"
                :index="i"
                :observation="observations[observationId]"
                :maxIndex="observationIds.length - 1"
        />
        <button class="btn btn-primary" v-on:click="addObservation">Add observation</button>
        <div class="action-container">
            <button class="btn btn-sm btn-secondary btn-move-up ml-2" v-on:click="moveObservationGroupUp" :disabled="!canMoveUp">
                <font-awesome-icon icon="chevron-up" />
            </button>

            <button class="btn btn-sm btn-secondary btn-move-down ml-2" v-on:click="moveObservationGroupDown" :disabled="!canMoveDown">
                <font-awesome-icon icon="chevron-down" />
            </button>

            <button class="btn btn-sm btn-danger btn-delete-observation-group ml-2" v-on:click="deleteObservationGroup">
                <font-awesome-icon icon="times" />
            </button>
        </div>
    </div>
</template>

<script>
    import extend from 'extend';
    import Observation from './Observation';
    import Vue from 'vue';
    import {createId} from "@/utils/idCreator";
    import {validateObservationGroup} from "@/utils/admin/indicators/ExceptionValidator";
    import { mapGetters } from 'vuex'
    import * as types from '@/store/mutation-types'
    import {objectKeyCount, objectKeys} from '@/utils/objectUtils';
    import EditableTextField from '@/components/common/editable-text-field';

    export default {
        name: 'observation-group',
        components: {
            Observation,
            EditableTextField,
        },
        props: {
            indicatorId: {
                type: Number
            },
            index: {
                type: Number,
            },
            observationGroup: {
                type: Object,
            },
            maxIndex: {
                type: Number,
                default: 0
            }
        },
        data() {
            let data = {
                error: null,

                id: null,

                observationIds: [],
                observations: {},

                title: null
            };

            if (this.observationGroup) {
                data = extend(data, this.observationGroup);
            }

            delete data['index'];
            delete data['indicatorId'];

            if (data.observationIds.length === 0 && objectKeyCount(data.observations)) {
                data.observationIds = objectKeys(data.observations);
            }

            return data;
        },
        watch: {
            observationGroup: {
                deep: true,
                handler() {
                    this.observationIds = objectKeys(this.observations);

                    this.checkErrors();
                }
            },
            title() {
                this.updateData();
            }
        },
        mounted() {
            this.updateData();
        },
        methods: {
            validate() {
                try {
                    let result = validateObservationGroup(this.observationGroup);

                    result = typeof(result) !== 'undefined' ? result : true;

                    this.error = null;

                    return result;
                } catch (error) {
                    this.error = error.message || error.toString();

                    return false;
                }
            },
            checkErrors() {
                this.validate(false);
                /*
                this.error = null;

                if (!this.observationIds.length) {
                    this.error = 'At least one observation is required.';

                    return;
                }

                let hasAtLeastOneRequired = false;

                for (let observationId in this.observations) {
                    let observation = this.observations[observationId];

                    if (observation.required) {
                        hasAtLeastOneRequired = true;
                    }
                }

                if (!hasAtLeastOneRequired) {
                    this.error = 'At least one observation needs to be set as required.';

                    return;
                }

                if (doesObservationsHaveCircularDependencies(this.observations)) {
                    this.error = 'Circular dependencies cannot be used.';

                    return;
                }*/
            },
            updateData() {
                this.$store.commit(types.SET_ACTIVE_INDICATOR_OBSERVATION_GROUP_DATA, {
                    observationGroupId: this.id,
                    observationGroupData: {
                        id: this.id,
                        observations: this.observations,
                        title: this.title
                    }
                });
            },
            addObservation() {
                let data = {
                    id: createId(),
                };

                Vue.set(this.observations, data.id, data);

                this.observationIds.push(data.id);
            },
            moveObservationGroupUp() {
                this.$emit('moveUp');
            },
            moveObservationGroupDown() {
                this.$emit('moveDown');
            },
            deleteObservationGroup() {
                this.$emit('delete');
            },
            swapObservations(index1, index2) {
                let observation1 = this.observationIds[index1];
                let observation2 = this.observationIds[index2];

                Vue.set(this.observationIds, index1, observation2);
                Vue.set(this.observationIds, index2, observation1);
            },
            onObservationMoveUp(index, id) {
                // Move up!
                this.swapObservations(index, index - 1);
            },
            onObservationMoveDown(index, id) {
                // Move down!
                this.swapObservations(index, index + 1);
            },
            onObservationDelete(id) {
                let _id = parseInt(id, 10);

                if (_id) {
                    id = _id; // It must be an int
                }

                for (let observationId in this.observations) {
                    let observation = this.observations[observationId];

                    if (observation.dependencyObservationId === id) {
                        observation.dependencyObservationId = null;
                    }
                }

                this.observationIds.splice(this.observationIds.indexOf(id), 1);

                Vue.delete(this.observations, id);

                this.$nextTick(() => {
                    this.$store.commit(types.REMOVE_ACTIVE_INDICATOR_OBSERVATION_DATA, {
                        observationGroupId: this.id,
                        observationId: id
                    });
                })
            },
        },
        computed: {
            canMoveUp() {
                return this.index > 0;
            },
            canMoveDown() {
                return this.index < this.maxIndex;
            },
            defaultTitle() {
                return `Observation group ${this.index + 1}`;
            },
            isSuccess() {
                return this.validate();
            }
        }
    }
</script>

<style scoped lang="scss">
    .observation-group {
        background: #d5dbe1;
        padding: 10px;
        margin: 15px;
        position: relative;

        &.is-error {
            border: 1px solid #ff5555;
            box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, .5);
            background: #ff7777;
        }
    }

    .action-container {
        position: absolute;
        top: 10px;
        right: 10px;
    }

    h3 {
        padding-right: 45px;
    }
</style>
